// ===================================================================
// src/app/core/guards/no-auth.guard.ts - حارس لمنع الوصول لصفحات المصادقة عند التوثيق
// ===================================================================
import { Injectable, inject } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { Observable, map, take } from 'rxjs';

import { AuthService } from '../services/auth.service';
import { NotificationService } from '../services/notification.service';

@Injectable({
  providedIn: 'root'
})
export class NoAuthGuard implements CanActivate {
  private authService = inject(AuthService);
  private router = inject(Router);
  private notificationService = inject(NotificationService);

  canActivate(): Observable<boolean | UrlTree> | boolean | UrlTree {
    return this.authService.isAuthenticated$.pipe(
      take(1),
      map(isAuthenticated => {
        // إذا كان المستخدم مصادقاً عليه، نعيد توجيهه للوحة التحكم
        if (isAuthenticated) {
          this.notificationService.info('أنت بالفعل مسجل الدخول');
          return this.router.createUrlTree(['/dashboard']);
        }

        // إذا لم يكن مصادقاً عليه، نسمح له بالوصول لصفحات المصادقة
        return true;
      })
    );
  }
}
